import script from "./UpdateAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateAlert.vue?vue&type=script&setup=true&lang=ts"

import "./UpdateAlert.vue?vue&type=style&index=0&id=6af4c88e&lang=scss"

const __exports__ = script;

export default __exports__